// extracted by mini-css-extract-plugin
export default {"hide":"styles_hide__iWdVd","greyed-out":"styles_greyed-out__bEuas","footer":"styles_footer__4ziPZ","footerText":"styles_footerText__uDBlv"};